import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';

const routes: Routes = [
  {
    path: '',
    component: HeaderComponent,
    children: [
      {
        path: '',
        redirectTo: '/',
        pathMatch: 'full',
      },
      {
        path: '',
        loadChildren: () =>
          import('./../landingpage/landingpage.module').then(
            (m) => m.LandingpageModule
          ),
      },
      {
        path: 'all-product',
        loadChildren: () =>
          import('./../all-product/all-product.module').then(
            (m) => m.AllProductModule
          ),
      },
      {
        path: 'all-recently-products',
        loadChildren: () =>
          import(
            './../all-recently-products/all-recently-products.module'
          ).then((m) => m.AllRecentlyProductsModule),
      },
      {
        path: 'all-categories',
        loadChildren: () =>
          import('./../all-categories/all-categories.module').then(
            (m) => m.AllCategoriesModule
          ),
      },
      {
        path: 'product-detail/:productId',
        loadChildren: () =>
          import('./../product-Detailview/product-Detailview.module').then(
            (m) => m.ProductDetailviewModule
          ),
      },
      {
        path: 'homepageProducts/:sectionId',
        loadChildren: () =>
          import('./../homepagesection/homepagesection.module').then(
            (m) => m.AllProductModule
          ),
      },
      {
        path: 'MyCart',
        loadChildren: () =>
          import('./../checkout-page/checkout-page.module').then(
            (m) => m.CheckoutPageModule
          ),
      },
      {
        path: 'upload-prescription',
        loadChildren: () =>
          import('./../upload-prescription/upload-prescription.module').then(
            (m) => m.UploadPrescriptionModule
          ),
      },
      {
        path: 'payment-process',
        loadChildren: () =>
          import('./../payment-process/payment-process.module').then(
            (m) => m.PaymentProcessModule
          ),
      },
      {
        path: 'category/:categoryName',
        loadChildren: () =>
          import('./../categories/categories.module').then(
            (m) => m.CategoriesModule
          ),
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./../login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'request-call',
        loadChildren: () =>
          import('./../request-call/request-call.module').then(
            (m) => m.RequestCallModule
          ),
      },
      {
        path: 'Order-successfully',
        loadChildren: () =>
          import('./../Order-successfully/Order-successfully.module').then(
            (m) => m.OrderSuccessfullyModule
          ),
      },
      {
        path: 'user-prescription',
        loadChildren: () =>
          import('./../home-prescription/home-prescription.module').then(
            (m) => m.HomePrescriptionModule
          ),
      },
      {
        path: 'privacy-policy',
        loadChildren: () =>
          import('./../privacy-policy/privacy-policy.module').then(
            (m) => m.PrivacyPolicyModule
          ),
      },
      {
        path: 'Notify',
        loadChildren: () =>
          import('./../Notify/Notify.module').then((m) => m.NotifyModule),
      },

      {
        path: 'terms-conditions',
        loadChildren: () =>
          import('./../terms-conditions/terms-conditions.module').then(
            (m) => m.TermsConditionsModule
          ),
      },
      {
        path: 'blog',
        loadChildren: () =>
          import('../user-profile/health-articals/health-articals.module').then(
            (m) => m.HealthArticalsModule
          ),
      },
      {
        path: 'Health-Articals',
        loadChildren: () =>
          import('../user-profile/health-articals/health-articals.module').then(
            (m) => m.HealthArticalsModule
          ),
      },
      {
        path: 'call-Back',
        loadChildren: () =>
          import(
            '../user-profile/call-back-availability/call-back-availability.module'
          ).then((m) => m.CallBackAvailabilityModule),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import('../user-profile/contact-us/contact-us.module').then(
            (m) => m.ContactUsModule
          ),
      },
      {
        path: 'HealthArtical-detail/:Health_Article_Id',
        loadChildren: () =>
          import(
            './../health-article-detailView/health-article-detailView.module'
          ).then((m) => m.HealthArticleDetailViewModule),
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HeaderRoutes {}
